import React from 'react';
import {RadioButton} from 'primereact/radiobutton';
import {Checkbox} from 'primereact/checkbox';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import {Fieldset} from "primereact/fieldset";
import Translate from "../../shared/language/Translate";
import {Button as ButtonImage} from "primereact/button";
import {Button} from 'reactstrap';
import WebMenuService from "../../shared/service/WebMenuService";
import {PAGE_MODE, WEB_IMAGE_SERVER_URL} from "../../shared/utils/Constants";
import {Chip} from "@material-ui/core";
import InputText from "../../shared/component/form/InputText";

const defaultItem = {
    id: null,
    longname: null,
    price: null,
    totalPrice: null,
    itemPrice: null,
    originalPrice: null,
    quantity: 1,
    description: null,
    code: null,
    pageMode: PAGE_MODE.CREATE
};

export default class ItemDetailsCheckOut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            item: defaultItem,
            showTop: true,
            viewMode: false,
            collapsedSections: {},
            validationError: null,
            invalidSection: null,
            headerImageBroken: false
        }
        this.webMenuService = new WebMenuService();
        this._dialogKeyHandler = this.handleTemplate3DialogKeyDown.bind(this);
    }

    componentDidMount() {
        this.setState({showTop: true});
    }

    componentDidUpdate(prevProps, prevState) {
        const dialogActive = this.props.template3UI && this.state.showTop;
        const wasDialogActive = this.props.template3UI && prevState.showTop;
        if (dialogActive && !wasDialogActive) {
            window.addEventListener('keydown', this._dialogKeyHandler);
        } else if (!dialogActive && wasDialogActive) {
            window.removeEventListener('keydown', this._dialogKeyHandler);
        }

        if (prevProps.dialogVisible && !this.props.dialogVisible) {
            if (this._hideContentTimer) {
                clearTimeout(this._hideContentTimer);
            }
            this._hideContentTimer = window.setTimeout(() => {
                this.setState({showTop: false, validationError: null, invalidSection: null});
            }, 320);
        } else if (!prevProps.dialogVisible && this.props.dialogVisible) {
            if (this._hideContentTimer) {
                clearTimeout(this._hideContentTimer);
            }
            this.setState({showTop: true, validationError: null, invalidSection: null});
        }
    }

    componentWillUnmount() {
        if (this._hideContentTimer) {
            clearTimeout(this._hideContentTimer);
        }
        window.removeEventListener('keydown', this._dialogKeyHandler);
    }

    handleTemplate3DialogKeyDown(e) {
        if (!this.props.template3UI || !this.state.showTop) {
            return;
        }
        if (e.key === 'Escape') {
            this.props.closeDisplayDialog();
            return;
        }
        if (e.key === 'Enter' && this.state.viewMode === false) {
            const tag = e.target && e.target.tagName ? e.target.tagName.toLowerCase() : '';
            if (tag === 'textarea' || tag === 'input') {
                return;
            }
            e.preventDefault();
            this.handleSubmit();
        }
    }

    /** Checkbox/radio focus'un dialog içeriğini scrollIntoView ile kaydırmasını engeller */
    preventOptionFocusScroll = (e) => {
        const target = e.target;
        if (!target) {
            return;
        }
        const tag = target.tagName ? target.tagName.toLowerCase() : '';
        const isOptionInput = tag === 'input'
            && (target.type === 'checkbox' || target.type === 'radio');
        const inOptionControl = target.closest
            && (target.closest('.p-checkbox')
                || target.closest('.p-radiobutton')
                || target.closest('.item-details-dialog__option-row')
                || target.closest('.item-details-option-tile')
                || target.closest('.item-details-quick-pick'));
        if (isOptionInput || inOptionControl) {
            e.preventDefault();
        }
    };

    getAccentColor() {
        const accent = this.props.accentColor;
        if (!GeneralUtils.isNullOrEmpty(accent)) {
            const color = String(accent).trim();
            return color.startsWith('#') ? color : `#${color}`;
        }
        return '#1982D9';
    }

    buildSections(item = this.state.item) {
        const sections = [];
        if (!item) {
            return sections;
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpContent)) {
            sections.push({
                key: 'grpContent',
                legend: 'Served With',
                group: item.grpContent,
                required: false,
                type: 'content'
            });
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpContentX)) {
            sections.push({
                key: 'grpContentX',
                legend: 'Extra(s)',
                group: item.grpContentX,
                required: false,
                type: 'content'
            });
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpMain)) {
            sections.push({
                key: 'grpMain',
                legend: 'Main Product',
                group: item.grpMain,
                required: true,
                type: 'single',
                optionText: item.grpMainText,
                optionLabel: ''
            });
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpOption1)) {
            sections.push({
                key: 'grpOption1',
                legend: item.grpOption1Label,
                group: item.grpOption1,
                required: item.grpOption1.selectionType === 'SINGLE',
                type: 'option',
                optionText: item.grpOption1Text,
                optionLabel: item.grpOption1Label
            });
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpOption2)) {
            sections.push({
                key: 'grpOption2',
                legend: item.grpOption2Label,
                group: item.grpOption2,
                required: item.grpOption2.selectionType === 'SINGLE',
                type: 'option',
                optionText: item.grpOption2Text,
                optionLabel: item.grpOption2Label
            });
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpOption3)) {
            sections.push({
                key: 'grpOption3',
                legend: item.grpOption3Label,
                group: item.grpOption3,
                required: item.grpOption3.selectionType === 'SINGLE',
                type: 'option',
                optionText: item.grpOption3Text,
                optionLabel: item.grpOption3Label
            });
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpOption4)) {
            sections.push({
                key: 'grpOption4',
                legend: item.grpOption4Label,
                group: item.grpOption4,
                required: item.grpOption4.selectionType === 'SINGLE',
                type: 'option',
                optionText: item.grpOption4Text,
                optionLabel: item.grpOption4Label
            });
        }
        return sections;
    }

    buildCollapsedSections(item = this.state.item) {
        const sections = this.buildSections(item);
        const collapsedSections = {};
        sections.forEach((section, index) => {
            collapsedSections[section.key] = index !== 0;
        });
        return collapsedSections;
    }

    clearValidation = () => {
        if (this.state.validationError || this.state.invalidSection) {
            this.setState({validationError: null, invalidSection: null});
        }
    };

    getSectionSelectionCount(section) {
        const grp = section.group;
        if (!grp || GeneralUtils.isNullOrEmpty(grp.products)) {
            return 0;
        }
        if (section.type === 'content') {
            return grp.products.filter((product) => product.selectedValue != null).length;
        }
        if (grp.selectionType === 'SINGLE') {
            return grp.products.some((product) => product.selectedValue != null) ? 1 : 0;
        }
        return grp.products.filter((product) => product.selectedValue != null).length;
    }

    getSectionLegend(section) {
        const count = this.getSectionSelectionCount(section);
        const label = section.legend || '';
        if (count > 0) {
            return `${label} (${count})`;
        }
        if (section.required) {
            return `${label} *`;
        }
        return label;
    }

    validateItem() {
        const sections = this.buildSections();
        for (let i = 0; i < sections.length; i++) {
            const section = sections[i];
            if (section.required && this.getSectionSelectionCount(section) === 0) {
                return {
                    valid: false,
                    sectionKey: section.key,
                    message: `Please choose an option in "${section.legend}".`
                };
            }
        }
        return {valid: true};
    }

    toggleSection = (sectionKey, collapsed) => {
        this.setState({
            collapsedSections: {
                ...this.state.collapsedSections,
                [sectionKey]: collapsed
            }
        });
    };

    setData = (data) => {
        data.itemPrice = data.originalPrice;
        data.pageMode = PAGE_MODE.UPDATE;
        data.totalPrice = data.originalPrice * data.quantity;
        data.originalPrice = data.price;

        this.setState({
            showTop: true,
            viewMode: false,
            item: data,
            headerImageBroken: false,
            ...(this.props.template3UI ? {
                collapsedSections: this.buildCollapsedSections(data),
                validationError: null,
                invalidSection: null
            } : {}),
        }, () => {
            this.calculatePrice();
        });
    }

    clearData = (data, viewMode) => {
        data.pageMode = PAGE_MODE.CREATE;
        data.description = data.longname;
        if (!GeneralUtils.isNullOrEmpty(data.grpContent)) {
            data.grpContent.products.forEach(product => {
                product.selectedValue = product.id;
            });
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpContentX)) {
            data.grpContentX.products.forEach(product => {
                product.selectedValue = null;
            });
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpMain)) {
            data.grpMain.products.forEach(product => {
                if (data.productId == product.id) {
                    product.selectedValue = data.productId;
                } else {
                    product.selectedValue = null;
                }
            });
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpOption1)) {
            data.grpOption1.products.forEach(product => {
                product.selectedValue = null;
            });
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpOption2)) {
            data.grpOption2.products.forEach(product => {
                product.selectedValue = null;
            });
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpOption3)) {
            data.grpOption3.products.forEach(product => {
                product.selectedValue = null;
            });
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpOption4)) {
            data.grpOption4.products.forEach(product => {
                product.selectedValue = null;
            });
        }
        data.totalPrice = data.price;
        data.originalPrice = data.price;
        data.itemPrice = data.price;
        data.code = data.id;
        data.quantity = 1;
        data.extraNotes = '';

        this.setState({
            showTop: true,
            viewMode: viewMode,
            item: data,
            headerImageBroken: false,
            ...(this.props.template3UI ? {
                collapsedSections: this.buildCollapsedSections(data),
                validationError: null,
                invalidSection: null
            } : {}),
        }, () => {
            this.calculatePrice();
        });
    }

    sumOfOptions = (grpOption, data) => {
        var result = 0;
        let i = 1;
        const zeroPriceLimit = this.getZeroPriceLimit(grpOption);
        if (grpOption.selectionType == "MULTIPLE") {
            grpOption.products.forEach(product => {
                if (product.selectedValue != null) {
                    data.description = data.description + " # " + product.longname;
                    data.code = data.code + "E" + product.id + "";
                    if (i > zeroPriceLimit) {
                        result = result + this.getPriceByPricingType(grpOption, product, data);
                    }
                    i++;
                }
            });
        }
        if (grpOption.selectionType == "SINGLE") {
            grpOption.products.forEach(product => {
                if (product.selectedValue != null) {
                    data.description = data.description + " # " + product.longname;
                    data.code = data.code + "E" + product.id + "";
                    result = result + this.getPriceByPricingType(grpOption, product, data);
                }
            });
        }
        return result;
    }

    getZeroPriceLimit = (grpOption) => {
        return GeneralUtils.isNullOrEmpty(grpOption.zeroPriceLimit) ? 0 : grpOption.zeroPriceLimit;
    }

    getPriceByPricingType = (grpOption, product, data) => {
        if (grpOption.pricingType == "PRODUCT_PRICE") {
            return this.normalizePriceValue(product.price);
        }
        if (grpOption.pricingType == "SET_PRICE") {
            return this.normalizePriceValue(grpOption.price);
        }
        if (grpOption.pricingType == "VARIABLE_PRICE") {
            return this.getVariablePrice(grpOption, product, data);
        }
        return 0;
    }

    normalizePriceValue = (value) => {
        if (GeneralUtils.isNullOrEmpty(value)) {
            return 0;
        }
        const parsedValue = parseFloat(value);
        return Number.isNaN(parsedValue) ? 0 : parsedValue;
    }

    parseProductQuantity = (product) => {
        if (!GeneralUtils.isNullOrEmpty(product) && !GeneralUtils.isNullOrEmpty(product.quantity)) {
            const quantity = parseFloat(product.quantity);
            if (!Number.isNaN(quantity) && quantity > 0) {
                return quantity;
            }
        }
        return null;
    }

    getSelectedMainProduct = (data) => {
        if (GeneralUtils.isNullOrEmpty(data) || GeneralUtils.isNullOrEmpty(data.grpMain) || GeneralUtils.isNullOrEmpty(data.grpMain.products)) {
            return null;
        }
        if (!GeneralUtils.isNullOrEmpty(data.productId)) {
            const selectedByProductId = data.grpMain.products.find(p => p.id == data.productId);
            if (!GeneralUtils.isNullOrEmpty(selectedByProductId)) {
                return selectedByProductId;
            }
        }
        const selectedByValue = data.grpMain.products.find(p => p.selectedValue != null);
        return GeneralUtils.isNullOrEmpty(selectedByValue) ? null : selectedByValue;
    }

    getSelectedMainProductQuantity = (data) => {
        const selectedMainProduct = this.getSelectedMainProduct(data);
        if (!GeneralUtils.isNullOrEmpty(selectedMainProduct)) {
            return this.parseProductQuantity(selectedMainProduct);
        }
        return null;
    }

    getSelectedMainProductIndex = (data) => {
        if (!GeneralUtils.isNullOrEmpty(data) && !GeneralUtils.isNullOrEmpty(data.grpMain) && !GeneralUtils.isNullOrEmpty(data.grpMain.products)) {
            if (!GeneralUtils.isNullOrEmpty(data.productId)) {
                const selectedByProductIdIndex = data.grpMain.products.findIndex(p => p.id == data.productId);
                if (selectedByProductIdIndex > -1) {
                    return selectedByProductIdIndex;
                }
            }
            return data.grpMain.products.findIndex(p => p.selectedValue != null);
        }
        return -1;
    }

    getVariablePriceQuantity = (grpOption, product, data) => {
        const selectedMainQuantity = this.getSelectedMainProductQuantity(data);
        if (!GeneralUtils.isNullOrEmpty(selectedMainQuantity)) {
            return selectedMainQuantity;
        }
        const selectedProductQuantity = this.parseProductQuantity(product);
        if (!GeneralUtils.isNullOrEmpty(selectedProductQuantity)) {
            return selectedProductQuantity;
        }
        return null;
    }

    getVariablePrice = (grpOption, product, data) => {
        if (GeneralUtils.isNullOrEmpty(grpOption.productGroupExtra) || GeneralUtils.isNullOrEmpty(grpOption.productGroupExtra.list)) {
            return 0;
        }
        const selectedMainIndex = this.getSelectedMainProductIndex(data);
        const itemQuantity = this.getVariablePriceQuantity(grpOption, product, data);
        const sortedList = grpOption.productGroupExtra.list
            .filter(p => !GeneralUtils.isNullOrEmpty(p) && !GeneralUtils.isNullOrEmpty(p.size) && !GeneralUtils.isNullOrEmpty(p.price))
            .sort((a, b) => parseFloat(a.size) - parseFloat(b.size));
        if (sortedList.length === 0) {
            return 0;
        }
        let priceItem = null;
        if (selectedMainIndex > -1) {
            const safeIndex = Math.min(selectedMainIndex, sortedList.length - 1);
            priceItem = sortedList[safeIndex];
        } else if (!GeneralUtils.isNullOrEmpty(itemQuantity) && itemQuantity > 0) {
            priceItem = sortedList.find(p => parseFloat(p.size) >= itemQuantity);
        }
        if (GeneralUtils.isNullOrEmpty(priceItem)) {
            priceItem = sortedList[0];
        }
        return GeneralUtils.isNullOrEmpty(priceItem) ? 0 : this.normalizePriceValue(priceItem.price);
    }

    calculatePrice = () => {
        var totalPriceOfOneItem = 0;
        let data = this.state.item;
        data.description = data.name;
        data.code = "";

        if (!GeneralUtils.isNullOrEmpty(data.grpContent)) {
            data.grpContent.products.forEach(product => {
                if (product.selectedValue == null) {
                    data.description = data.description + " # No";
                    data.code = data.code + "N" + product.id + "";
                    data.description = data.description + " " + product.name;
                } else {
                    data.code = data.code + "Y" + product.id + "";
                }
            });
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpContentX)) {
            data.grpContentX.products.forEach(product => {
                if (product.selectedValue != null) {
                    data.description = data.description + " # With";
                    data.code = data.code + "W" + product.id + "";
                    data.description = data.description + " " + product.name;
                    data.selectedValue = product.id;
                }
            });
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpMain)) {
            let sumOf = this.sumOfOptions(data.grpMain, data);
            totalPriceOfOneItem = totalPriceOfOneItem + sumOf;
        } else {
            if (GeneralUtils.isNullOrEmpty(data.itemPrice)) {
                totalPriceOfOneItem = totalPriceOfOneItem + data.originalPrice;
            } else {
                totalPriceOfOneItem = totalPriceOfOneItem + data.itemPrice;
            }
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpOption1)) {
            let sumOf = this.sumOfOptions(data.grpOption1, data);
            totalPriceOfOneItem = totalPriceOfOneItem + sumOf;
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpOption2)) {
            let sumOf = this.sumOfOptions(data.grpOption2, data);
            totalPriceOfOneItem = totalPriceOfOneItem + sumOf;
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpOption3)) {
            let sumOf = this.sumOfOptions(data.grpOption3, data);
            totalPriceOfOneItem = totalPriceOfOneItem + sumOf;
        }
        if (!GeneralUtils.isNullOrEmpty(data.grpOption4)) {
            let sumOf = this.sumOfOptions(data.grpOption4, data);
            totalPriceOfOneItem = totalPriceOfOneItem + sumOf;
        }
        data.price = totalPriceOfOneItem;
        data.totalPrice = (totalPriceOfOneItem * data.quantity);
        this.setState({item: data});
    }

    handleSubmit = () => {
        const validation = this.validateItem();
        if (!validation.valid) {
            this.setState({
                validationError: validation.message,
                invalidSection: validation.sectionKey,
                collapsedSections: {
                    ...this.state.collapsedSections,
                    [validation.sectionKey]: false
                }
            });
            return;
        }

        this.calculatePrice();
        let data = this.state.item;
        if (data.pageMode == PAGE_MODE.CREATE) {
            data.id = null;
            this.setState({item: data});
        }
        if (GeneralUtils.isSetMenu(this.state.item)) {
            this.props.addSetMenuItem(this.state.item);
        } else {
            this.props.addProduct(this.state.item);
        }
    };

    getSelectedExtrasCount() {
        let count = 0;
        this.buildSections().forEach((section) => {
            if (section.key === 'grpContent') {
                return;
            }
            count += this.getSectionSelectionCount(section);
        });
        return count;
    }

    renderDialogHeader() {
        const item = this.state.item;
        const hidePrice = localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") === "true";
        const hasImage = !GeneralUtils.isNullOrEmpty(item.webImagePath) && !this.state.headerImageBroken;
        const imageSrc = hasImage ? WEB_IMAGE_SERVER_URL + item.webImagePath : null;

        return (
            <div className={`item-details-dialog__header${hasImage ? "" : " item-details-dialog__header--no-image"}`}>
                {hasImage && (
                    <div className="item-details-dialog__header-media">
                        <img
                            onError={() => this.setState({headerImageBroken: true})}
                            src={imageSrc}
                            alt={item.longname || item.name || ''}
                        />
                    </div>
                )}
                <div className="item-details-dialog__header-text">
                    <h3 className="item-details-dialog__title">{item.longname || item.name}</h3>
                    {!hidePrice && !GeneralUtils.isNullOrEmpty(item.price) && (
                        <p className="item-details-dialog__unit-price">
                            £{item.price.toFixed(2)}
                            {!GeneralUtils.isNullOrEmpty(item.quantity) && item.quantity > 1 ? ` · ×${item.quantity}` : ''}
                        </p>
                    )}
                </div>
            </div>
        );
    }

    renderNotesField() {
        if (GeneralUtils.isNullOrEmpty(this.state.item.price) || !GeneralUtils.isSetMenu(this.state.item)) {
            return null;
        }
        return (
            <div className="item-details-dialog__notes">
                <label className="item-details-dialog__notes-label" htmlFor="itemExtraNotes">
                    Extra notes (optional)
                </label>
                <InputText
                    value={this.state.item.extraNotes}
                    style={{borderRadius: "10px", width: "-webkit-fill-available"}}
                    name="extraNotes"
                    id="itemExtraNotes"
                    placeholder="Let the restaurant know"
                    disabled={this.state.viewMode}
                    rows={2}
                    cols={60}
                    maxLength={50}
                    onChange={this.__handleChange}
                />
            </div>
        );
    }

    renderQuantityControls() {
        const item = this.state.item;
        if (GeneralUtils.isNullOrEmpty(item.price)) {
            return null;
        }
        return (
            <div className="item-details-dialog__qty">
                <ButtonImage
                    icon={"pi pi-minus"}
                    disabled={item.quantity <= 1}
                    className="item-details-dialog__qty-btn"
                    onClick={() => {
                        let data = this.state.item;
                        if (data.quantity > 1) {
                            if (data.weighable == true && data.unit == "kg") {
                                data.quantity = parseFloat(data.quantity) - parseFloat(0.1);
                                data.quantity = data.quantity.toFixed(2);
                            } else {
                                data.quantity = data.quantity - 1;
                            }
                        }
                        this.setState({item: data}, this.calculatePrice);
                    }}
                />
                <span className="item-details-dialog__qty-value">
                    {item.weighable == true && item.unit == "kg"
                        ? `${item.quantity} ${item.unit}`
                        : item.quantity}
                </span>
                <ButtonImage
                    icon={"pi pi-plus"}
                    className="item-details-dialog__qty-btn"
                    onClick={() => {
                        let data = this.state.item;
                        if (data.weighable == true && data.unit == "kg") {
                            data.quantity = parseFloat(data.quantity) + parseFloat(0.1);
                            data.quantity = data.quantity.toFixed(2);
                        } else {
                            data.quantity = data.quantity + 1;
                        }
                        this.setState({item: data}, this.calculatePrice);
                    }}
                />
            </div>
        );
    }

    renderFooterSummaryLine() {
        const item = this.state.item;
        if (GeneralUtils.isNullOrEmpty(item.price)) {
            return null;
        }
        const name = item.longname || item.name || 'Item';
        const qty = item.quantity || 1;
        const qtyLabel = item.weighable === true && item.unit === 'kg'
            ? `${qty} ${item.unit}`
            : `${qty}×`;
        const extrasCount = this.getSelectedExtrasCount();
        const hidePrice = localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") === "true";

        return (
            <div className="item-details-dialog__summary-line">
                <span className="item-details-dialog__summary-main">
                    {qtyLabel} {name}
                    {extrasCount > 0 ? ` · ${extrasCount} extra${extrasCount > 1 ? 's' : ''}` : ''}
                </span>
                {!hidePrice && (
                    <span className="item-details-dialog__summary-total">£{item.totalPrice.toFixed(2)}</span>
                )}
            </div>
        );
    }

    renderPriceSummary() {
        const item = this.state.item;
        if (GeneralUtils.isNullOrEmpty(item.price) || localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") === "true") {
            return null;
        }
        return (
            <div className="item-details-dialog__price-summary">
                <span>Total £{item.totalPrice.toFixed(2)}</span>
            </div>
        );
    }

    renderDialogFooter() {
        return (
            <div className="item-details-dialog__footer">
                {this.renderFooterSummaryLine()}
                {this.renderQuantityControls() && (
                    <div className="item-details-dialog__footer-qty">
                        {this.renderQuantityControls()}
                    </div>
                )}
                <div className="item-details-dialog-footer item-details-dialog-footer--template3">
                    <Button
                        color="secondary"
                        outline
                        type="button"
                        className="item-details-dialog-btn-dismiss"
                        onClick={() => {
                            this.props.closeDisplayDialog();
                        }}
                    >
                        <Translate contentKey="entity.action.add">Close</Translate>
                    </Button>
                    {this.state.viewMode == false &&
                        <Button
                            color="primary"
                            type="button"
                            className="item-details-dialog-btn-submit"
                            onClick={this.handleSubmit}
                        >
                            <Translate contentKey="entity.action.add">Add to order</Translate>
                        </Button>
                    }
                </div>
            </div>
        );
    }

    render() {
        if (this.state.showTop == false) {
            return null;
        }
        if (this.props.template3UI) {
            return this.renderTemplate3Dialog();
        }
        return this.renderLegacyDialog();
    }

    renderTemplate3Dialog() {
        const accent = this.getAccentColor();
        return (
            <div
                className="item-details-dialog"
                style={{"--item-accent": accent}}
                onMouseDown={this.preventOptionFocusScroll}
            >
                {this.renderDialogHeader()}
                <div className="item-details-dialog__scroll-wrap">
                    <div className="item-details-dialog__scroll">
                        {this.state.validationError && (
                            <div className="item-details-dialog__alert" role="alert">
                                {this.state.validationError}
                            </div>
                        )}
                        {this.renderProductTags()}
                        {this.renderProductTextDetails()}
                        {this.renderNotesField()}
                    </div>
                    <div className="item-details-dialog__scroll-fade" aria-hidden="true"/>
                </div>
                {this.renderDialogFooter()}
            </div>
        );
    }

    renderLegacyDialog() {
        const accent = this.getAccentColor();
        const itemName = this.state.item.longname || this.state.item.name;
        return (
            <div
                className="item-details-dialog item-details-dialog--legacy"
                style={{"--item-accent": accent}}
                onMouseDown={this.preventOptionFocusScroll}
            >
                {!GeneralUtils.isNullOrEmpty(itemName) && (
                    <h3 className="item-details-dialog__legacy-title">{itemName}</h3>
                )}
                <div className="item-details-dialog__scroll-wrap">
                    <div className="item-details-dialog__scroll">
                        <div className="orderlist-demo">
                            {this.renderLegacyItemDetails()}
                            {this.renderLegacyProductTags()}
                            {this.renderLegacyNotesField()}
                        </div>
                    </div>
                    <div className="item-details-dialog__scroll-fade" aria-hidden="true"/>
                </div>
                {this.renderLegacyDialogFooter()}
            </div>
        );
    }

    renderLegacyItemDetails() {
        let form = [];
        const item = this.state.item;
        let styleSetMenu = {
            maxWidth: '15vw',
            maxHeight: '15vw'
        };
        let styleProduct = {
            maxWidth: '5vw',
            maxHeight: '5vw'
        };

        if (GeneralUtils.isMobile()) {
            styleSetMenu = {
                maxWidth: '60vw',
                maxHeight: '60vw'
            };
            styleProduct = {
                maxWidth: '20vw',
                maxHeight: '20vw'
            };
        }

        if (!GeneralUtils.isNullOrEmpty(item.webImagePath) && !this.state.headerImageBroken) {
            const imageStyle = GeneralUtils.isSetMenu(item) ? styleSetMenu : styleProduct;
            form.push(
                <div className="image-container" align={"center"} key="legacy-item-image">
                    <img
                        onError={() => this.setState({headerImageBroken: true})}
                        src={WEB_IMAGE_SERVER_URL + item.webImagePath}
                        style={imageStyle}
                        alt={item.longname}
                    />
                </div>
            );
        }

        form.push(this.renderLegacyProductTextDetails());
        return form;
    }

    renderLegacyProductTextDetails() {
        let form = [];
        const item = this.state.item;

        if (!GeneralUtils.isNullOrEmpty(item.grpContent)) {
            form.push(
                <Fieldset key="legacy-grpContent" legend={"Served With"}>
                    {this.renderLegacyContentAndExtra(item.grpContent)}
                </Fieldset>
            );
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpContentX)) {
            form.push(
                <Fieldset key="legacy-grpContentX" legend={"Extra(s)"}>
                    {this.renderLegacyContentAndExtra(item.grpContentX)}
                </Fieldset>
            );
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpMain)) {
            const grpOption = item.grpMain;
            grpOption.selectionType = "SINGLE";
            form.push(
                <Fieldset key="legacy-grpMain" legend={"Main Product"}>
                    {this.renderLegacyOption(item.grpMain, item.grpMainText, "")}
                </Fieldset>
            );
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpOption1)) {
            form.push(
                <Fieldset key="legacy-grpOption1" legend={item.grpOption1Label}>
                    {this.renderLegacyOption(item.grpOption1, item.grpOption1Text, item.grpOption1Label)}
                </Fieldset>
            );
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpOption2)) {
            form.push(
                <Fieldset key="legacy-grpOption2" legend={item.grpOption2Label}>
                    {this.renderLegacyOption(item.grpOption2, item.grpOption2Text, item.grpOption2Label)}
                </Fieldset>
            );
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpOption3)) {
            form.push(
                <Fieldset key="legacy-grpOption3" legend={item.grpOption3Label}>
                    {this.renderLegacyOption(item.grpOption3, item.grpOption3Text, item.grpOption3Label)}
                </Fieldset>
            );
        }
        if (!GeneralUtils.isNullOrEmpty(item.grpOption4)) {
            form.push(
                <Fieldset key="legacy-grpOption4" legend={item.grpOption4Label}>
                    {this.renderLegacyOption(item.grpOption4, item.grpOption4Text, item.grpOption4Label)}
                </Fieldset>
            );
        }
        return form;
    }

    renderLegacyProductTags() {
        const item = this.state.item;
        if (!GeneralUtils.isNullOrEmpty(item.tag4Name) || !GeneralUtils.isNullOrEmpty(item.tag5Name)
            || !GeneralUtils.isNullOrEmpty(item.tag1Name) || !GeneralUtils.isNullOrEmpty(item.tag2Name)
            || !GeneralUtils.isNullOrEmpty(item.tag3Name)) {
            return (
                <Fieldset legend={"Product Tags"}>
                    <div className="orderlist-demo">
                        {!GeneralUtils.isNullOrEmpty(item.tag1Name) &&
                            <Chip label={item.tag1Name} style={{backgroundColor: '#1982D9', color: 'white'}}/>
                        }
                        {!GeneralUtils.isNullOrEmpty(item.tag2Name) &&
                            <Chip label={item.tag2Name} style={{backgroundColor: '#1982D9', color: 'white'}}/>
                        }
                        {!GeneralUtils.isNullOrEmpty(item.tag3Name) &&
                            <Chip label={item.tag3Name} style={{backgroundColor: '#1982D9', color: 'white'}}/>
                        }
                        {!GeneralUtils.isNullOrEmpty(item.tag4Name) &&
                            <Chip label={item.tag4Name} style={{backgroundColor: '#1982D9', color: 'white'}}/>
                        }
                        {!GeneralUtils.isNullOrEmpty(item.tag5Name) &&
                            <Chip label={item.tag5Name} style={{backgroundColor: '#1982D9', color: 'white'}}/>
                        }
                    </div>
                </Fieldset>
            );
        }
        return "";
    }

    renderLegacyNotesField() {
        const item = this.state.item;
        if (GeneralUtils.isNullOrEmpty(item.price) || !GeneralUtils.isSetMenu(item)) {
            return null;
        }
        return (
            <div className="item-details-dialog__notes item-details-dialog__notes--legacy">
                <label className="item-details-dialog__notes-label" htmlFor="legacyExtraNotes">
                    Any specific preferences? Let the restaurant know.
                </label>
                <InputText
                    value={item.extraNotes}
                    style={{borderRadius: "10px", width: "-webkit-fill-available"}}
                    name="extraNotes"
                    id="legacyExtraNotes"
                    placeholder="Notes"
                    disabled={this.state.viewMode}
                    rows={2}
                    cols={60}
                    maxLength={50}
                    onChange={this.__handleChange}
                />
            </div>
        );
    }

    renderLegacyDialogFooter() {
        const item = this.state.item;
        if (GeneralUtils.isNullOrEmpty(item.price)) {
            return this.renderLegacyButtons();
        }
        return (
            <div className="item-details-dialog__footer item-details-dialog__footer--legacy">
                {this.renderFooterSummaryLine()}
                {this.renderQuantityControls() && (
                    <div className="item-details-dialog__footer-qty">
                        {this.renderQuantityControls()}
                    </div>
                )}
                {this.renderLegacyButtons()}
            </div>
        );
    }

    renderLegacyButtons() {
        return (
            <div className="item-details-dialog-footer item-details-dialog-footer--legacy">
                <Button
                    color="secondary"
                    outline
                    type="button"
                    className="item-details-dialog-btn-dismiss"
                    onClick={() => {
                        this.props.closeDisplayDialog();
                    }}
                >
                    <Translate contentKey="entity.action.add">Close</Translate>
                </Button>
                {this.state.viewMode == false &&
                    <Button
                        color="primary"
                        type="button"
                        className="item-details-dialog-btn-submit"
                        onClick={() => {
                            this.calculatePrice();
                            let data = this.state.item;
                            if (data.pageMode == PAGE_MODE.CREATE) {
                                data.id = null;
                                this.setState({item: data});
                            }
                            if (GeneralUtils.isSetMenu(this.state.item)) {
                                this.props.addSetMenuItem(this.state.item);
                            } else {
                                this.props.addProduct(this.state.item);
                            }
                        }}
                    >
                        <Translate contentKey="entity.action.add">Add to order</Translate>
                    </Button>
                }
            </div>
        );
    }

    renderLegacyOptionRow(inputId, selected, control, labelText) {
        return (
            <label
                htmlFor={inputId}
                key={inputId}
                className={`item-details-dialog__option-row${selected ? " item-details-dialog__option-row--selected" : ""}`}
            >
                {control}
                <span className="item-details-dialog__option-text">{labelText}</span>
            </label>
        );
    }

    renderLegacyContentAndExtra(groupList) {
        const data = this.state.item;
        return (
            <div className="item-details-dialog__option-grid">
                {groupList.products.map((product, index) => {
                    const inputId = `legacy-content-${product.id}-${index}`;
                    const selected = product.selectedValue == product.id;
                    return this.renderLegacyOptionRow(
                        inputId,
                        selected,
                        <Checkbox
                            inputId={inputId}
                            name={product.name}
                            value={product.id}
                            onChange={(e) => {
                                product.selectedValue = e.checked ? e.value : null;
                                this.setState({item: data});
                                this.calculatePrice();
                            }}
                            checked={selected}
                        />,
                        product.name
                    );
                })}
            </div>
        );
    }

    renderLegacyOption(grpOption, grpOptionText, grpOptionLabel) {
        let optionDescription = grpOptionText.replace(grpOptionLabel, "");
        try {
            if (optionDescription.indexOf("(") < 0 && optionDescription.indexOf(")") < 0) {
                optionDescription = "";
            } else {
                optionDescription = optionDescription.substring(optionDescription.indexOf("(") + 1, optionDescription.indexOf(")"));
            }
        } catch (e) {
            optionDescription = grpOptionText.replace(grpOptionLabel, "");
        }

        const radioGroupName = `legacy-grp-${grpOption.id}`;
        const hidePrice = localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") === "true";

        return (
            <React.Fragment>
                {!GeneralUtils.isNullOrEmpty(optionDescription) && (
                    <p className="item-details-dialog__option-desc">{optionDescription}</p>
                )}
                <div className="item-details-dialog__option-grid">
                    {grpOption.products.map((product, index) => {
                        const inputId = `legacy-opt-${grpOption.id}-${product.id}-${index}`;
                        const optionPrice = this.getPriceByPricingType(grpOption, product, this.state.item);
                        const priceLabel = !hidePrice && !GeneralUtils.isNullOrEmpty(optionPrice) && optionPrice > 0
                            ? ` (£${optionPrice.toFixed(2)})`
                            : "";

                        if (grpOption.selectionType == "MULTIPLE") {
                            const selected = product.selectedValue == product.id;
                            return this.renderLegacyOptionRow(
                                inputId,
                                selected,
                                <Checkbox
                                    inputId={inputId}
                                    name={product.longname}
                                    value={product.id}
                                    onChange={(e) => {
                                        product.selectedValue = e.checked ? e.value : null;
                                        let item = this.state.item;
                                        this.setState({item: item});
                                        this.calculatePrice();
                                    }}
                                    checked={selected}
                                />,
                                `${product.longname}${priceLabel}`
                            );
                        }

                        const selected = product.selectedValue == product.id;
                        return this.renderLegacyOptionRow(
                            inputId,
                            selected,
                            <RadioButton
                                inputId={inputId}
                                name={radioGroupName}
                                value={product.id}
                                onChange={(e) => {
                                    product.selectedValue = e.value;
                                    let item = this.state.item;
                                    if (!GeneralUtils.isNullOrEmpty(item.grpMain) && grpOption.id == item.grpMain.id) {
                                        item.productId = product.id;
                                        item.productBssId = product.bssId;
                                    }
                                    this.setState({item: item});
                                    this.setFalseToUnselected(grpOption.products, product);
                                    this.calculatePrice();
                                }}
                                checked={selected}
                            />,
                            `${product.longname}${priceLabel}`
                        );
                    })}
                </div>
            </React.Fragment>
        );
    }

    renderProductTags() {
        const item = this.state.item;
        const hasTags = !GeneralUtils.isNullOrEmpty(item.tag4Name)
            || !GeneralUtils.isNullOrEmpty(item.tag5Name)
            || !GeneralUtils.isNullOrEmpty(item.tag1Name)
            || !GeneralUtils.isNullOrEmpty(item.tag2Name)
            || !GeneralUtils.isNullOrEmpty(item.tag3Name);
        if (!hasTags) {
            return null;
        }

        const accent = this.getAccentColor();
        return (
            <div className="item-details-dialog__tags">
                {!GeneralUtils.isNullOrEmpty(item.tag1Name) &&
                    <Chip label={item.tag1Name} style={{backgroundColor: accent, color: 'white'}}/>
                }
                {!GeneralUtils.isNullOrEmpty(item.tag2Name) &&
                    <Chip label={item.tag2Name} style={{backgroundColor: accent, color: 'white'}}/>
                }
                {!GeneralUtils.isNullOrEmpty(item.tag3Name) &&
                    <Chip label={item.tag3Name} style={{backgroundColor: accent, color: 'white'}}/>
                }
                {!GeneralUtils.isNullOrEmpty(item.tag4Name) &&
                    <Chip label={item.tag4Name} style={{backgroundColor: accent, color: 'white'}}/>
                }
                {!GeneralUtils.isNullOrEmpty(item.tag5Name) &&
                    <Chip label={item.tag5Name} style={{backgroundColor: accent, color: 'white'}}/>
                }
            </div>
        );
    }

    renderCollapsibleSection(section) {
        const isInvalid = this.state.invalidSection === section.key;
        const collapsed = this.state.collapsedSections[section.key] === true;
        let content = null;

        if (section.type === 'content') {
            content = this.renderContentAndExtra(section.group);
        } else if (section.key === 'grpMain') {
            const grpOption = section.group;
            grpOption.selectionType = "SINGLE";
            content = this.renderOption(grpOption, section.optionText, section.optionLabel);
        } else {
            content = this.renderOption(section.group, section.optionText, section.optionLabel);
        }

        return (
            <div
                key={section.key}
                className={`item-details-card${collapsed ? " item-details-card--collapsed" : " item-details-card--open"}${isInvalid ? " item-details-card--error" : ""}${this.getSectionSelectionCount(section) > 0 ? " item-details-card--filled" : ""}`}
            >
                <button
                    type="button"
                    className="item-details-card__header"
                    onClick={() => this.toggleSection(section.key, !collapsed)}
                    aria-expanded={!collapsed}
                >
                    <span className="item-details-card__title">{this.getSectionLegend(section)}</span>
                    <span className="item-details-card__toggle" aria-hidden="true">{collapsed ? "+" : "−"}</span>
                </button>
                {!collapsed && (
                    <div className="item-details-card__body orderlist-demo">
                        {this.renderSectionQuickPicks(section)}
                        {content}
                    </div>
                )}
            </div>
        );
    }

    renderProductTextDetails() {
        return this.buildSections().map((section) => this.renderCollapsibleSection(section));
    }

    setFalseToUnselected = (itemList, data) => {
        for (var i = 0; i < itemList.length; i++) {
            if (itemList[i].id != data.id) {
                itemList[i].selectedValue = null;
            }
        }
    }

    renderSectionQuickPicks(section) {
        if (!section.group || GeneralUtils.isNullOrEmpty(section.group.products)) {
            return null;
        }
        const legend = (section.legend || '').toLowerCase();
        if (legend.indexOf('salad') === -1) {
            return null;
        }

        const products = section.group.products;
        const noSalad = products.find((p) => /no\s*salad/i.test(String(p.longname || p.name || '')));
        const allSalad = products.find((p) => /all\s*salad/i.test(String(p.longname || p.name || '')));
        if (!noSalad && !allSalad) {
            return null;
        }

        const isMultiple = section.group.selectionType === 'MULTIPLE' || section.type === 'content';
        return (
            <div className="item-details-quick-picks">
                {noSalad && (
                    <button
                        type="button"
                        className={`item-details-quick-pick${noSalad.selectedValue == noSalad.id ? " item-details-quick-pick--selected" : ""}`}
                        onClick={() => this.applyQuickPick(section.group, noSalad, isMultiple, true)}
                    >
                        {noSalad.longname || noSalad.name}
                    </button>
                )}
                {allSalad && (
                    <button
                        type="button"
                        className={`item-details-quick-pick${allSalad.selectedValue == allSalad.id ? " item-details-quick-pick--selected" : ""}`}
                        onClick={() => this.applyQuickPick(section.group, allSalad, isMultiple, false)}
                    >
                        {allSalad.longname || allSalad.name}
                    </button>
                )}
            </div>
        );
    }

    applyQuickPick(grpOption, targetProduct, isMultiple, clearOthers) {
        const item = this.state.item;
        if (!isMultiple) {
            grpOption.products.forEach((product) => {
                product.selectedValue = null;
            });
            targetProduct.selectedValue = targetProduct.id;
            if (!GeneralUtils.isNullOrEmpty(item.grpMain) && grpOption.id == item.grpMain.id) {
                item.productId = targetProduct.id;
                item.productBssId = targetProduct.bssId;
            }
        } else if (clearOthers) {
            grpOption.products.forEach((product) => {
                product.selectedValue = null;
            });
            targetProduct.selectedValue = targetProduct.id;
        } else {
            targetProduct.selectedValue = targetProduct.selectedValue == targetProduct.id ? null : targetProduct.id;
        }
        this.setState({item: item}, () => {
            this.clearValidation();
            this.calculatePrice();
        });
    }

    renderContentAndExtra(groupList) {
        let data = this.state.item;
        let form = [];
        groupList.products.forEach((product, index) => {
            form.push(
                <Checkbox
                    key={`content-${product.id}-${index}`}
                    name={product.name}
                    value={product.id}
                    onChange={(e) => {
                        product.selectedValue = e.checked ? e.value : null;
                        this.setState({item: data}, () => {
                            this.clearValidation();
                            this.calculatePrice();
                        });
                    }}
                    checked={product.selectedValue == product.id}
                />
            );
            form.push(<label key={`content-gap-${index}`} htmlFor="productItem">&nbsp;&nbsp;&nbsp;</label>);
            form.push(
                <label key={`content-label-${index}`} htmlFor="productItem">
                    <h8 style={{overflow: 'hidden'}}>{product.name}</h8>
                </label>
            );
            form.push(<p key={`content-p-${index}`}></p>);
        });
        return form;
    }

    renderOption(grpOption, grpOptionText, grpOptionLabel) {
        let form = [];
        let optionDescription = grpOptionText.replace(grpOptionLabel, "");
        try {
            if (optionDescription.indexOf("(") < 0 && optionDescription.indexOf(")") < 0) {
                optionDescription = "";
            } else {
                optionDescription = optionDescription.substring(optionDescription.indexOf("(") + 1, optionDescription.indexOf(")"));
            }
        } catch (e) {
            optionDescription = grpOptionText.replace(grpOptionLabel, "");
        }
        if (!GeneralUtils.isNullOrEmpty(optionDescription)) {
            form.push(<p key="option-desc" className="item-details-option-desc">{optionDescription}</p>);
        }

        grpOption.products.forEach((product, index) => {
            if (grpOption.selectionType == "MULTIPLE") {
                form.push(
                    <Checkbox
                        key={`opt-multi-${product.id}-${index}`}
                        inputId={String(product.id)}
                        name={product.longname}
                        value={product.id}
                        onChange={(e) => {
                            product.selectedValue = e.checked ? e.value : null;
                            let item = this.state.item;
                            this.setState({item: item}, () => {
                                this.clearValidation();
                                this.calculatePrice();
                            });
                        }}
                        checked={product.selectedValue == product.id}
                    />
                );
                form.push(<label key={`opt-multi-gap-${index}`} htmlFor="productItem">&nbsp;&nbsp;&nbsp;</label>);
                form.push(<label key={`opt-multi-label-${index}`} htmlFor="productItem">{product.longname}</label>);
                if (localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") != "true") {
                    const optionPrice = this.getPriceByPricingType(grpOption, product, this.state.item);
                    if (!GeneralUtils.isNullOrEmpty(optionPrice) && optionPrice > 0) {
                        form.push(" (£");
                        form.push(<label key={`opt-multi-price-${index}`} htmlFor="productItem">{optionPrice.toFixed(2)}</label>);
                        form.push(")");
                    }
                }
                form.push(<p key={`opt-multi-p-${index}`}></p>);
            } else {
                form.push(
                    <RadioButton
                        key={`opt-single-${product.id}-${index}`}
                        inputId={String(product.id)}
                        name={product.longname}
                        value={product.id}
                        onChange={(e) => {
                            product.selectedValue = e.value;
                            let item = this.state.item;
                            if (!GeneralUtils.isNullOrEmpty(item.grpMain) && grpOption.id == item.grpMain.id) {
                                item.productId = product.id;
                                item.productBssId = product.bssId;
                            }
                            this.setState({item: item}, () => {
                                this.clearValidation();
                                this.setFalseToUnselected(grpOption.products, product);
                                this.calculatePrice();
                            });
                        }}
                        checked={product.selectedValue == product.id}
                    />
                );
                form.push(<label key={`opt-single-gap-${index}`} htmlFor="productItem">&nbsp;&nbsp;&nbsp;</label>);
                form.push(<label key={`opt-single-label-${index}`} htmlFor="productItem">{product.longname}</label>);
                const optionPrice = this.getPriceByPricingType(grpOption, product, this.state.item);
                if (!GeneralUtils.isNullOrEmpty(optionPrice) && optionPrice > 0 && localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") != "true") {
                    form.push(" (£");
                    form.push(<label key={`opt-single-price-${index}`} htmlFor="productItem">{optionPrice.toFixed(2)}</label>);
                    form.push(")");
                }
                form.push(<p key={`opt-single-p-${index}`}></p>);
            }
        });
        return form;
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let item = this.state.item;
        item[e.target.name] = value;
        this.setState({item: item});
    }
}
